import React, { useEffect, useState, FC } from "react";
import { Button } from "antd";
import "../Dashboard/Dashboard.scss";

const CallNotification: FC<{
  page?: any;
  sender?: string;
  onAccept: (page: CallNotificationPageObj) => void;
  onDecline: () => void;
  allUsers?: any;
}> = ({
  page = { title: "NUMAN TEST" },
  sender = "1132",
  onAccept,
  onDecline,
  allUsers
}) => {
  const [audio, setAudio] = useState<HTMLAudioElement>();


  useEffect(() => {


    console.log('call notification', page, sender);

    const sound = new Audio("/audio/ring-normal.wav");
    sound.loop = true;
    setAudio(sound);
    return () => {
      console.log(sound);
      sound.pause();
    };
  }, []);

  useEffect(() => {
    if (audio) {
      audio.play();
      if(page.b2t){
        setTimeout(()=>{
          audio.pause();
        },2000)
      }
      setTimeout(()=>{
        onDecline();
      },10000)
    }
  }, [audio]);

  const getFriendUser = (members) => {
    const userIndex = Object.keys(members).find((x) => {
      return x !== localStorage.getItem("RID");
    });
    const user = allUsers?.find((obj) => obj.id === userIndex);
    return {
      profileImage: user?.profileImage?.urls?.original?.url,
      beamId: user?.beamId,
    };
    // return user?.beamId;
  };


  return (
    <div className="video-invitation-wrapper">
      <div className="call-animation">
        <Button className="beam-btn accept-call" onClick={() => onAccept(page)}>
          <img className="action-icon" src="/images/call.png" />
        </Button>
        <div className="title">
          {/* <h3>{page.title}</h3> */}
          <h4>
            Video Call
            <br />
            <span>({page?.page?.persistent?.static?.metadata?.title ||
            (page?.page?.persistent?.static?.metadata?.type === "friend" &&
            getFriendUser(page?.page?.persistent?.static?.metadata?.members?.users)
              ?.beamId
              ? getFriendUser(
                page?.page?.persistent?.static?.metadata?.members?.users
                )?.beamId
              : `Page ${page?.page?.pageId}`)})</span>
          </h4>
        </div>
        <Button className="beam-btn deny-call" onClick={onDecline}>
          <img className="action-icon" src="/images/call.png" />
        </Button>
      </div>
    </div>
    // <React.Fragment>

    // </React.Fragment>
  );
};

export default CallNotification;
